'use client';

import {
  useEffect
} from 'react';

import
  Breadcrumb
from '@/app/ui/breadcrumb';

import
  GradientOverlay
from '@/app/ui/gradient-overlay';

interface BreadcrumbItem {
  label: string
  href?: string
}

interface PageBannerProps {
  title: string
  breadcrumbs: BreadcrumbItem[]
}

export default function PageBanner({
  title, breadcrumbs
}: PageBannerProps) {

  // Header defaults to opaque (safe against a plain white page). This dark
  // hero is the one background it can safely start transparent-on-scroll
  // against, so opt into that here and hand opacity back on unmount -
  // otherwise navigating from a banner page to a plain one would leave the
  // header stuck transparent.
  useEffect(() => {

    window.dispatchEvent(new CustomEvent('nav-force-opaque', {
      detail: false
    }));

    return () => {

      window.dispatchEvent(new CustomEvent('nav-force-opaque', {
        detail: true
      }));
    };
  }, []);

  return (
    <section className="relative overflow-hidden pt-28 pb-16 px-6 sm:px-8">
      <GradientOverlay />

      <div className="relative z-10 max-w-4xl mx-auto">
        <Breadcrumb items={breadcrumbs} />
        <h1 className="text-3xl sm:text-4xl font-light text-white">
          {title}
        </h1>
      </div>
    </section>
  );
}
